<template>
  <div class="page-container">
    <!-- Кривая линия -->
    <div class="curve-line" v-if="showCurve">
      <svg class="curve-svg" viewBox="0 0 100 1000" preserveAspectRatio="none">
        <path class="curve-path" d="M50,0 C70,50 30,150 50,200 C70,250 30,350 50,400 C70,450 30,550 50,600 C70,650 30,750 50,800 C70,850 30,950 50,1000" />
      </svg>
    </div>
    
    <main class="implants-page">
      <section class="silimed">
        <h2 class="section-title animate-element" ref="sectionTitle">{{ $t('type.start')}}</h2>

        <div class="silimed-banner animate-element" ref="silimedBanner">
          <img src="/img/inplants_testur.jpg" alt="Silimed">
        </div>
      
        <div class="silimed-buttons animate-element" ref="silimedButtons">
          <a href="#" @click="goToBiodesin">{{ $t('type.bio')}}</a>
          <a href="#" @click="goToStandard">{{ $t('type.stand')}}</a>
          <a href="#" @click="goToType">{{ $t('type.types')}}</a>
        </div>
      
        <div class="silimed-text animate-element" ref="silimedText">
          <h2>{{ $t('type.top')}}</h2>
          <p>{{ $t('type.agree')}}</p>
          <p>{{$t('type.choose')}}</p>
        </div>
      </section>

      <section id="models" aria-label="Модели и варианты">
        <div class="container">
          <div class="grid grid-5">
            <!-- Card 1 -->
            <div class="card model-red animate-element" ref="card1">
              <div class="cart-img">
                <img class="model-img" src="/img/cart-select/Peru.jpg" alt="" />
              </div>
              <div class="card-availability">
                <h3 class="card-title">PURE POLYURETHANE</h3>
                <p>{{ $t('type.low')}}<sup style="font-size:.75em; line-height:0; vertical-align:super; margin-left:2px;">1</sup></p>
                <p>{{ $t('type.adg')}}<sup style="font-size:.75em; line-height:0; vertical-align:super; margin-left:2px;">2</sup></p>
                <p>{{  $t('type.for') }}<sup style="font-size:.75em; line-height:0; vertical-align:super; margin-left:2px;">3</sup></p>
              </div>
            </div>

            <!-- Card 2 -->
            <div class="card model-blue animate-element" ref="card2">
              <div class="cart-img">
                <img class="model-img" src="/img/cart-select/true.png" alt="" />
              </div>
              <div class="card-availability">
                <h3 class="card-title">TRUE TEXTURE</h3>
                <p>{{ $t('type.true')}}</p>
                <p>{{ $t('type.true1')}}<sup style="font-size:.75em; line-height:0; vertical-align:super; margin-left:2px;">4</sup>{{ $t('type.true2')}}<sup style="font-size:.75em; line-height:0; vertical-align:super; margin-left:2px;">5</sup>{{ $t('type.true3')}}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
        
      <section class="implants-page-end">
        <h2 class="animate-element" ref="pageEndTitle">{{ $t('type.lit')}}</h2>

        <p class="animate-element" ref="pageEndP1"><sup style="font-size:.75em; line-height:0; vertical-align:super; margin-left:2px;">1</sup>{{ $t('type.lit1')}}</p>
        <p class="animate-element" ref="pageEndP2"><sup style="font-size:.75em; line-height:0; vertical-align:super; margin-left:2px;">2</sup>{{ $t('type.lit2')}}</p>
        <p class="animate-element" ref="pageEndP3"><sup style="font-size:.75em; line-height:0; vertical-align:super; margin-left:2px;">3</sup>{{ $t('type.lit3')}}</p>
        <p class="animate-element" ref="pageEndP4"><sup style="font-size:.75em; line-height:0; vertical-align:super; margin-left:2px;">4</sup>{{ $t('type.lit4')}}</p>
        <span class="animate-element" ref="pageEndSpan"><sup style="font-size:.75em; line-height:0; vertical-align:super; margin-left:2px;">5</sup>{{ $t('type.lit5')}}</span>
      </section>
    </main>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
  name: 'MainBiodesign',
  data() {
    return {
      showCurve: true
    }
  },
  setup() {
    const router = useRouter()

    function goToBiodesin() {
      router.push("/biodesain")
    }
    function goToStandard() {
      router.push("/standardline")
    }
    function goToType() {
      router.push("/type")
    }

    return { goToBiodesin, goToStandard, goToType }
  },
  mounted() {
    this.initAnimations();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 🔹 метод для перевода
    switchLang(lang) {
      this.$i18n.locale = lang
    },

    initAnimations() {
      if (this.showCurve) {
        setTimeout(() => {
          const curveLine = document.querySelector('.curve-line');
          if (curveLine) {
            curveLine.classList.add('animate-curve');
          }
        }, 100);
      }

      const isElementInViewport = (el) => {
        const rect = el.getBoundingClientRect();
        return (
          rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 0.9 &&
          rect.bottom >= 0
        );
      };

      const handleScroll = () => {
        const elements = document.querySelectorAll('.animate-element');
        elements.forEach(element => {
          if (isElementInViewport(element)) {
            element.classList.add('animate');
          }
        });
      };

      window.addEventListener('load', handleScroll);
      window.addEventListener('scroll', handleScroll);
      handleScroll();
    },

    handleResize() {
      this.showCurve = window.innerWidth > 768;
    }
  }
}
</script>

<style scoped>
*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* Контейнер для всей страницы с отступом */
/* === Базовые стили === */
.page-container {
  position: relative;
  max-width: 1200px;
  margin: 70px auto;
  padding: 0 20px;
}

.container {
  text-align: left;
  margin: 70px auto;
  max-width: 1200px;
  padding: 0 20px;
}

.silimed {
  text-align: center;
  margin: 70px auto;
  max-width: 1200px;
  padding: 0 20px;
}

.section-title {
  color: #505050;
  font-size: 36px;
  font-weight: 300;
  line-height: 48px;
  margin-bottom: 100px;
}

.silimed-banner {
  margin-bottom: 30px;
  padding: 5px;
  border: 1px solid rgba(15, 131, 129, .14);
  width: 100%;
}

.silimed-banner img{
  width: 100%;
}

.silimed-buttons {
  margin: 30px 0;
  display: flex;
  justify-content: center;
  gap: 40px;
  height: 100px;
  width: 100%;
}

.silimed-buttons a {
  color: #108381;
  font-size: 16px;
  font-weight: 200;
  line-height: 76px;
  position: relative;
  width: calc(33.333% - 28px);
  margin: 15px 0;
  padding: 0 15px;
  transition: .2s linear;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  border: 1px solid #0f8381;
  background: #fff;
}

.silimed-buttons a:hover {
  background: teal;
  color: #fff;
}

.silimed-text {
  max-width: 1160px;
  margin: 0 auto;
  text-align: left;
}

.silimed-text h2 {
  color: #0d1016;
  font-size: 30px;
  font-weight: 100;
  margin-bottom: 25px;
}

.silimed-text p {
  font-weight: 300;
  line-height: 30px;
  margin-bottom: 25px;
  color: #555;
  font-size: 18px;
}

/* === Карточки имплантов === */
.grid-5 {
  display: grid;
  row-gap: 50px;
}

.model-red,
.model-blue {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 40px;
  text-align: left;
  padding: 30px;
}

.model-red {
  border: 1px solid #f07e23;
}

.model-blue {
  border: 1px solid #006da2;
}

.card-title {
  color: #888;
  font-size: 18px;
  font-weight: 400;
  margin: 0 0 25px;
}

.card-availability p {
  font-size: 16px;
  font-weight: 300;
  color: #3D3D3D;
  margin-bottom: 20px;
}

/* === Литература === */
.implants-page-end {
  display: grid;
  row-gap: 40px;
  text-align: left;
  margin: 70px auto;
  max-width: 1200px;
  padding: 0 20px;
}

.implants-page-end h2 {
  color: #3d3d3d;
  font-size: 13px;
  font-weight: 300;
}

.implants-page-end p,
.implants-page-end span {
  color: #3d3d3d;
  font-size: 13px;
  font-weight: 400;
}

/* === Кривая линия === */
.curve-line {
  position: absolute;
  top: 0;
  left: -80px;
  width: 100px;
  height: 100%;
  z-index: -1;
}

.curve-svg {
  width: 100%;
  height: 100%;
}

.curve-path {
  fill: none;
  stroke: #0b8482;
  stroke-width: 2;
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  transition: stroke-dashoffset 2s ease-in-out;
}

.animate-curve .curve-path {
  stroke-dashoffset: 0;
}

/* === Анимация появления === */
.animate-element {
  transform: translateX(-100px);
  opacity: 0;
  transition: transform 0.8s ease-out, opacity 0.8s ease;
}

.animate {
  transform: translateX(0) !important;
  opacity: 1 !important;
}

/* === Адаптация для планшетов и телефонов === */
@media (max-width: 1024px) {
  .silimed-buttons {
    gap: 20px;
  }

  .silimed-buttons a {
    font-size: 14px;
    line-height: 50px;
  }

  .model-red,
  .model-blue {
    gap: 20px;
    padding: 20px;
  }
}

@media (max-width: 768px) {
  .curve-line {
    display: none;
  }

  .silimed-buttons {
    flex-direction: column;
    height: auto;
    gap: 15px;
  }

  .silimed-buttons a {
    width: 100%;
    line-height: 50px;
  }

  .model-red,
  .model-blue {
    flex-direction: column;
    text-align: center;
  }

  .silimed-text {
    text-align: center;
  }

  .implants-page-end {
    text-align: center;
  }
}

@media (max-width: 480px) {
  .section-title {
    font-size: 26px;
    line-height: 36px;
  }

  .silimed-text h2 {
    font-size: 22px;
  }

  .silimed-text p {
    font-size: 16px;
    line-height: 24px;
  }

  .card-title {
    font-size: 16px;
  }

  .card-availability p {
    font-size: 14px;
  }
}

</style>